import { useTranslation } from 'react-i18next'
import BeatLoader from 'react-spinners/BeatLoader';

import articlePlaceHolder from 'assets/images/home/cover_placeholder.png'
import * as spriteIcons from 'assets/svg/sprite'
import { createdUpdatedAtShort } from 'helpers/date/created-updated-at-short'
import { useGetSectionsWithCategoryId } from 'pages/howTo/service/react-query/useGetSectionsWithId/useGetSectionsWithId'
import { useFilterAndSearchStore } from 'pages/howTo/store/filterAndSearch'
import {
    type IArticle,
    type IArticleSearchItem
} from 'pages/howTo/types/interfaces/IHowTo'

import { FilterSections } from './components/FilterSections/FilterSections'
import { Card } from '../../common/Card/Card'

interface ITutorialsProps {
    id?: number
    searchArticles?: IArticleSearchItem[]
}

export const Tutorials = ({ id, searchArticles = [] }: ITutorialsProps) => {
    const { t } = useTranslation()

    const { data: tutorials, isLoading } = useGetSectionsWithCategoryId(id)

    let filteredArticles: IArticleSearchItem[] | IArticle[] | undefined = []

    const filterId = useFilterAndSearchStore(state => state.filterId)
    const searchTerm = useFilterAndSearchStore(state => state.searchTerm)

    if (filterId === null && !searchTerm.query) {
        filteredArticles = tutorials?.data?.message.flatMap(obj => obj.articles)
    } else if (filterId !== null && !searchTerm.query) {
        filteredArticles = tutorials?.data.message.find(
            item => item.id === filterId
        )?.articles
    } else if (searchArticles?.length) {
        filteredArticles = searchArticles
    }

    if (isLoading) return <BeatLoader size={8} />

    return (
        <div className='tutorials-main'>
            <FilterSections filters={tutorials?.data?.message} />
            {filteredArticles?.length ? (
                filteredArticles?.map(article => (
                    <Card
                        key={article.id}
                        id={article.id}
                        type='tutorials'
                        sectionName='Tutorials'
                        title={article.title}
                        date={createdUpdatedAtShort(article.created_at)}
                        img={<spriteIcons.IconHowToBookLarge />}
                    />
                ))
            ) : (
                <span>{t('noResults')}</span>
            )}
        </div>
    )
}
